module.exports = __webpack_public_path__ + "translations/en/common.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/common.json
// module id = ./translations/en/common.json
// module chunks = 1